<template>
  <div class="xmxy_container" v-loading.fullscreen.lock="fullscreenLoading">
    <div>
      <!-- <div class="tips" style="color: red; margin-top: -10px">
        项目续约统计2022年1月1日至当前日期后一年，所有合同状态为“合同服务中”以及“合同完结”的数据服务项目。
      </div> -->
      <div>
        <el-date-picker
          v-model="year"
          type="year"
          size="small"
          style="width: 150px; margin-bottom: 15px"
          format="yyyy"
          placeholder="选择年"
          value-format="yyyy"
          :picker-options="pickerOptions"
          @change="hanleChangeYear"
          :clearable="false"
        ></el-date-picker>
      </div>
      <div class="card_1">
        <div class="card_1_item" @click="handleToTj(1)">
          <div>
            <span>到期项目数</span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="合同终止日期为当年，且项目状态为“项目服务中”“项目完结”的DS项目总数"
                placement="top"
              >
                <img
                  src="@/img/tips.png"
                  width="16"
                  alt
                  style="margin-left: 15px"
                />
              </el-tooltip>
            </span>
          </div>
          <div>{{ zxlc.xmxyIndexData.xyxmCount }}</div>
        </div>
        <div class="card_1_item" @click="handleToTj(1)">
          <div>
            <span>已续约项目数</span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中续约结果登记为“续约成功”的项目总数"
                placement="top"
              >
                <img
                  src="@/img/tips.png"
                  width="16"
                  alt
                  style="margin-left: 15px"
                />
              </el-tooltip>
            </span>
          </div>
          <div>{{ zxlc.xmxyIndexData.yxyxmCount }}</div>
        </div>
        <div class="card_1_item" @click="handleToTj(1)">
          <div>
            <span>未续约项目数</span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="到期项目中续约结果未登记以及续约结果登记为“续约不成功”的项目总数"
                placement="top"
              >
                <img
                  src="@/img/tips.png"
                  width="16"
                  alt
                  style="margin-left: 15px"
                />
              </el-tooltip>
            </span>
          </div>
          <div>{{ zxlc.xmxyIndexData.wxyxmCount }}</div>
        </div>
        <div class="card_1_item" @click="handleToTj(1)">
          <div>
            <span>续约基础工作执行率</span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="合同期限在1年及以上的到期项目中，已完成项目效果自评、成绩单规划清单、成绩单一览表、一把手认知评估合计数/合同期限1年及以上的项目数*4"
                placement="top"
              >
                <img
                  src="@/img/tips.png"
                  width="16"
                  alt
                  style="margin-left: 15px"
                />
              </el-tooltip>
            </span>
          </div>
          <div>{{ zxlc.xmxyIndexData.xyjcgzZxl || 0 }}%</div>
        </div>
        <div class="card_1_item" @click="handleToTj(1)">
          <div>
            <span>续约工作流程执行率</span>
            <span>
              <el-tooltip
                class="item"
                effect="dark"
                content="合同期限在1年及以上的到期项目中，已完成客户拜访、策略研讨、续约汇报合计数/合同期限1年及以上的项目数*3"
                placement="top"
              >
                <img
                  src="@/img/tips.png"
                  width="16"
                  alt
                  style="margin-left: 15px"
                />
              </el-tooltip>
            </span>
          </div>
          <div>{{ zxlc.xmxyIndexData.xylcZxl || 0 }}%</div>
        </div>
      </div>
      <div class="xmxy_middle">
        <div class="card_4">
          <div class="card_title">
            <span>快捷链接</span>
          </div>
          <div class="card_4_content">
            <div @click="applyDialog = true" v-if="user.bntqxzt == 2">
              续约发函申请
            </div>
            <div @click="handleToFh()" v-if="user.bntqxzt == 0">续约发函</div>
            <div @click="handleToFh(0)" v-if="user.bntqxzt == 2">
              续约发函确认（{{ zxlc.xmxyIndexData.dclCount }}）
            </div>
            <div @click="handleToFh(1)" v-if="user.bntqxzt == 1">
              发函处理（{{ zxlc.xmxyIndexData.dclCount }}）
            </div>
            <div @click="handleToMx()">续约明细</div>
            <div @click="handleToTj()">续约统计</div>
          </div>
        </div>
        <!-- <div class="card_2" >
          <div class="card_title">
            <span>续约专项流程执行动态</span>
          </div>
          <div>
            <el-table
              :max-height="300"
              :data="zxlc.xmxyIndexData.xylcZxList"
              fit
              highlight-current-row
              :default-sort="{ prop: 'date', order: 'descending' }"
              tooltip-effect="dark"
            >
              <el-table-column
                label="项目名称"
                align="left"
                prop="xmmc"
                min-width="150px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="最佳模型节点"
                align="left"
                prop="name"
                min-width="105px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="执行人"
                align="left"
                prop="zxr"
                min-width="65px"
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="执行状态"
                align="left"
                prop="dict_label"
                min-width="100px"
                sortable
                :show-overflow-tooltip="true"
              />
              <el-table-column
                label="预计完成时间"
                align="left"
                prop="end_time"
                min-width="130px"
                sortable
                :show-overflow-tooltip="true"
              />
              <template slot="empty">
                <div class="nodata">
                  <img src="@/img/nodata.png" alt="" width="160" />
                  <div>暂无数据</div>
                </div>
              </template>
            </el-table>
          </div>
        </div> -->
        <div class="card_2">
          <div class="card_title">
            <span>续约基础工作执行率</span>
          </div>
          <div class="card_2_content">
            <div
              id="card_2_chart"
              v-show="
                zxlc.xmxyIndexData.xylcZxlList &&
                zxlc.xmxyIndexData.xylcZxlList.length > 0
              "
            ></div>
            <el-empty
              description="暂无数据"
              v-show="
                !zxlc.xmxyIndexData.xylcZxlList ||
                zxlc.xmxyIndexData.xylcZxlList.length == 0
              "
            ></el-empty>
          </div>
        </div>
        <div class="card_3">
          <div class="card_title">
            <span>续约工作流程执行率</span>
          </div>
          <div class="card_3_content">
            <div
              id="card_3_chart"
              v-show="
                zxlc.xmxyIndexData.xylcZxlList &&
                zxlc.xmxyIndexData.xylcZxlList.length > 0
              "
            ></div>
            <el-empty
              description="暂无数据"
              v-show="
                !zxlc.xmxyIndexData.xylcZxlList ||
                zxlc.xmxyIndexData.xylcZxlList.length == 0
              "
            ></el-empty>
          </div>
        </div>
      </div>
      <div class="xmxy_bottom">
        <div class="card_5">
          <div class="card_title">
            <span>分公司到期项目数</span>
          </div>
          <div class="card_5_content">
            <div class="card_5_content_left">
              <div class="card_5_suntitle">项目数量</div>
              <div
                id="card_5_chart"
                v-show="
                  zxlc.xmxyIndexData.xyxmList &&
                  zxlc.xmxyIndexData.xyxmList.length > 0
                "
              ></div>
              <el-empty
                description="暂无数据"
                v-show="
                  !zxlc.xmxyIndexData.xyxmList ||
                  zxlc.xmxyIndexData.xyxmList.length == 0
                "
              ></el-empty>
            </div>
            <div class="card_5_content_right">
              <div class="card_5_suntitle">续约基础工作执行率排行</div>
              <div>
                <div
                  v-for="(item, index) in zxlc.xmxyIndexData.xyjcgzZxlphList"
                  :key="index"
                >
                  <span>
                    <span class="rank_index">{{ index + 1 }}</span>
                    <span>{{ item.bmmc }}</span>
                  </span>
                  <span>{{ item.zb }}%</span>
                </div>
              </div>
            </div>
            <div class="card_5_content_right">
              <div class="card_5_suntitle">续约流程执行率排行</div>
              <div>
                <div
                  v-for="(item, index) in zxlc.xmxyIndexData.xylcZxlphList"
                  :key="index"
                >
                  <span>
                    <span class="rank_index">{{ index + 1 }}</span>
                    <span>{{ item.bmmc }}</span>
                  </span>
                  <span>{{ item.zb }}%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="项目续约发函申请"
      :visible.sync="applyDialog"
      width="90%"
      v-if="applyDialog"
      id="mx-dialog"
    >
      <XmxyApply ref="apply" @giveFather="getSon"></XmxyApply>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit(1)">提 交</el-button>
        <el-button @click="applyDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import * as echarts from "echarts";
import XmxyApply from "@/views/zxlc/xmxy/applyForm";
import moment from "moment";
import "moment/locale/zh-cn";
export default {
  name: "xmxy_index",
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc"]),
  },
  components: { XmxyApply },
  data() {
    return {
      roleName: "",
      mxParams: {},
      applyDialog: false,
      pickerOptions: {
        disabledDate(time) {
          let threeYearsAgo = new Date().getFullYear() - 3;
          let nextYear = new Date().getFullYear() + 1;
          return (
            time.getFullYear() < threeYearsAgo || time.getFullYear() > nextYear
          );
        },
      },
      year: new Date().getFullYear() + "",
      fullscreenLoading: false,
    };
  },
  created() {
    // setTimeout(() => {
    //   const docH = document.documentElement.clientHeight;
    //   document.querySelector(".xmxy_container").style.minHeight =
    //     docH - 100 + "px";
    // }, 50);
    if (!this.zxlc.xmxyIndexData?.xyxmCount) {
      this.fullscreenLoading = true;
      this.$store
        .dispatch("zxlc/fetchXmxyIndexDataAction", { year: this.year })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.code == 0) {
            this.randerBar2(
              false,
              "card_3_chart",
              this.zxlc.xmxyIndexData.xylcZxlList
            );
            this.randerBar2(
              false,
              "card_2_chart",
              this.zxlc.xmxyIndexData.xyjcgzZxlList
            );
            this.randerBar();
          }
        });
    } else {
      this.$nextTick(() => {
        this.randerBar2(
          false,
          "card_3_chart",
          this.zxlc.xmxyIndexData.xylcZxlList
        );
        this.randerBar2(
          false,
          "card_2_chart",
          this.zxlc.xmxyIndexData.xyjcgzZxlList
        );
        this.randerBar();
      });
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      if (sessionStorage.getItem("acitveNameZxlc") == "first") {
        if (
          this.zxlc.xmxyIndexData.xylcZxlList &&
          this.zxlc.xmxyIndexData.xylcZxlList.length > 0
        ) {
          this.randerBar2(
            true,
            "card_3_chart",
            this.zxlc.xmxyIndexData.xylcZxlList
          );
        }
        if (
          this.zxlc.xmxyIndexData.xyjcgzZxlList &&
          this.zxlc.xmxyIndexData.xyjcgzZxlList.length > 0
        ) {
          this.randerBar2(
            true,
            "card_2_chart",
            this.zxlc.xmxyIndexData.xyjcgzZxlList
          );
        }
        if (
          this.zxlc.xmxyIndexData.xyxmList &&
          this.zxlc.xmxyIndexData.xyxmList.length > 0
        ) {
          this.randerBar(true);
        }
      }
    });
    // const timer = setInterval(() => {
    //   if (this.zxlc.xmxyIndexData.xylcZxlList) {
    //     this.randerBar2();
    //     clearInterval(timer);
    //   }
    //   if (this.zxlc.xmxyIndexData.xyxmList) {
    //     this.randerBar();
    //     clearInterval(timer);
    //   }
    // }, 100);
  },
  methods: {
    handleClick() {},
    randerBar(isResize) {
      var chartDom = document.getElementById("card_5_chart");
      var myChart = echarts.init(chartDom);
      var option;
      if (isResize) {
        myChart.resize();
        return;
      }
      let xList = [];
      let yList = [];

      const data = this.zxlc.xmxyIndexData.xyxmList.reverse();
      data.forEach((item) => {
        xList.push(item.bmmc);
        yList.push(item.xms);
      });
      option = {
        grid: {
          left: "8%",
          right: "3%",
          top: "6%",
          bottom: "12%",
        },
        xAxis: {
          type: "category",
          data: xList,
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
          },
          axisLabel: {
            color: "#333",
          },
        },
        yAxis: {
          type: "value",
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        series: [
          {
            data: yList,
            type: "bar",
            barWidth: "30",
            itemStyle: {
              normal: {
                color: "#036eb8",
                label: {
                  show: true,
                  textStyle: {
                    //数值样式
                    color: "#666", //字体颜色
                  },
                  position: "top",
                },
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    handleDealFilter(arr, key, replaceKey) {
      let newArr = [];
      arr.forEach((item, index) => {
        for (var i = 0; i < key.length; i++) {
          item[key] = item[replaceKey];
        }
        newArr.push(item);
      });
      return newArr;
    },
    randerBar2(isResize, boxId, data) {
      var chartDom = document.getElementById(boxId);
      data = data.reverse();
      var myChart = echarts.init(chartDom);
      var option;
      if (isResize) {
        myChart.resize();
        return;
      }
      let labelList = [];
      let dataList = [];
      data.forEach((item) => {
        labelList.push(item.jdmc);
        dataList.push(item.zb);
      });
      option = {
        tooltip: {
          trigger: "item",
          formatter: function (arr) {
            return `${arr.name}  ${arr.value}%`;
          },
        },
        grid: {
          left: "25%",
          // right: "50%",
        },
        // legend: {
        //   type: "plain",
        //   top: "5%",
        //   orient: "vertical",
        //   itemWidth: 16,
        //   formatter: (name) => {
        //     //  自定义图例
        //     let arr = [];
        //     let percent;
        //     for (const item of dataList) {
        //       if (item.name === name) {
        //         percent = item.value + "%";
        //       }
        //     }
        //     arr = ["{a|" + name + "}", "{b|" + percent + "}"];
        //     return `${name} | ${percent}`;
        //   },
        // },
        xAxis: {
          type: "value",
          data: dataList,
          axisTick: {
            alignWithLabel: true,
            show: true,
          },

          axisLine: {
            lineStyle: {
              color: "#ccc",
            },
            show: true,
          },
          axisLabel: {
            color: "#333",
            show: true,
            formatter: function (value) {
              return ` ${value}%`;
            },
          },
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          type: "category",
          data: labelList,
          axisLabel: {
            color: "#333",
            rotate: -45,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: { color: "#ccc" },
          },
        },

        series: [
          {
            data: dataList,
            type: "bar",
            barWidth: "15",
            itemStyle: {
              normal: {
                color: (params) => {
                  const colorList = [
                    "#036eb8",
                    "#36CBCB",
                    "#4DCB73",
                    "#FAD53F",
                    "#F2637B",
                    "#975FE4",
                    "#036eb8",
                    "#36CBCB",
                    "#4DCB73",
                    "#FAD53F",
                    "#F2637B",
                    "#975FE4",
                    "#036eb8",
                    "#36CBCB",
                    "#4DCB73",
                    "#FAD53F",
                    "#F2637B",
                    "#975FE4",
                  ];
                  return colorList[params.dataIndex];
                },
                label: {
                  show: true,
                  textStyle: {
                    //数值样式
                    color: "#666", //字体颜色
                  },
                  position: "right",
                  formatter: function (arr) {
                    return ` ${arr.value}%`;
                  },
                },
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    renderPie(isResize) {
      var chartDom = document.getElementById("card_3_chart");

      var myChart = echarts.init(chartDom);
      var option;
      if (isResize) {
        myChart.resize();
        return;
      }
      const data = this.handleDealFilter(
        this.zxlc.xmxyIndexData.xylcZxlList,
        "value",
        "zb"
      );
      option = {
        tooltip: {
          trigger: "item",
          formatter: function (arr) {
            return `${arr.name}  ${arr.value}%`;
          },
        },
        grid: {
          left: "0%",
        },
        legend: {
          top: "5%",
          left: "right",
          orient: "vertical",
          itemWidth: 16,
          itemWidth: 16,
          itemStyle: {},
          formatter: (name) => {
            //  自定义图例
            let arr = [];
            let percent;
            for (const item of data) {
              if (item.name === name) {
                percent = item.value + "%";
              }
            }
            arr = ["{a|" + name + "}", "{b|" + percent + "}"];
            return `${name} | ${percent}`;
          },
        },
        color: [
          "#036eb8",
          "#36CBCB",
          "#4DCB73",
          "#FAD53F",
          "#F2637B",
          "#975FE4",
        ],
        series: [
          {
            name: "",
            type: "pie",
            radius: ["40%", "60%"],
            avoidLabelOverlap: false,
            center: ["30%", "50%"],
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: false,
                fontSize: 20,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data,
          },
        ],
      };
      option && myChart.setOption(option);
    },
    handleSubmit() {
      this.$refs.apply.submitUpload();
    },
    getSon(temp) {
      this.applyDialog = false;
      this.$store.dispatch("zxlc/fetchXmxyIndexDataAction", {
        year: this.year,
      });
    },
    hanleChangeYear(e) {
      this.fullscreenLoading = true;
      this.year = e;
      this.$store
        .dispatch("zxlc/fetchXmxyIndexDataAction", { year: e })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.code == 0) {
            this.randerBar2(
              false,
              "card_3_chart",
              this.zxlc.xmxyIndexData.xylcZxlList
            );
            this.randerBar2(
              false,
              "card_2_chart",
              this.zxlc.xmxyIndexData.xyjcgzZxlList
            );
            this.randerBar();
          }
        });
    },
    handleToMx() {
      //测试生产使用
      localStorage.removeItem("zxlc_xmxy_mx_bmbh");
      var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=82`;
      var menuName = "续约明细";
      var dataIndex = Math.round(Math.random() * 10000);
      var data1 = { dataIndex, dataUrl, menuName };
      window.parent.postMessage(data1, "*");
    },
    handleToTj(xmzt) {
      //测试生产使用
      if (xmzt !== undefined) {
        localStorage.setItem("zxlc_xmxy_tj_xmzt", xmzt);
      } else {
        localStorage.removeItem("zxlc_xmxy_tj_xmzt");
      }
      localStorage.setItem("zxlc_xmxy_tj_year", this.year);
      var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=83`;
      var menuName = "续约统计";
      var dataIndex = Math.round(Math.random() * 10000);
      var data1 = { dataIndex, dataUrl, menuName };
      window.parent.postMessage(data1, "*");
    },
    handleToFh(lcjd) {
      //测试生产使用
      if (lcjd !== undefined) {
        localStorage.setItem("zxlc_xmxy_fh_lcjd", lcjd);
      } else {
        localStorage.removeItem("zxlc_xmxy_fh_lcjd");
      }
      var dataUrl = `/menuRedirect?systemType=tmis-pmp&redireType=tmis&menuType=81`;
      var menuName = "发函处理";
      var dataIndex = Math.round(Math.random() * 10000);
      var data1 = { dataIndex, dataUrl, menuName };
      window.parent.postMessage(data1, "*");
    },
  },
};
</script>
<style lang='less' scoped>
.xmxy_container {
  padding: 15px;
  background-color: #f3f3f4;
  height: 100%;
  .card_1 {
    display: flex;
    justify-content: space-between;
    line-height: 44px;
    .card_1_item {
      background-color: #fff;
      padding: 15px 0px;
      text-align: center;
      font-size: 20px;
      color: #000;
      font-weight: 600;
      cursor: pointer;
      width: 18%;
      box-sizing: border-box;
    }
  }
  .xmxy_middle {
    display: flex;
    margin-top: 15px;
    min-height: 300px;
    .card_2 {
      width: calc(40% - 8px);
      margin-right: 8px;
      min-height: 300px;
      max-height: 400px;
      margin-left: 16px;
      background-color: #fff;
      .card_2_content {
        height: calc(100% - 65px);
        #card_2_chart {
          height: 100%;
        }
      }
    }
    .card_3 {
      margin-left: 8px;
      width: calc(40% - 8px);
      background-color: #fff;
      .card_3_content {
        height: calc(100% - 65px);
        #card_3_chart {
          height: 100%;
        }
      }
    }
    .card_4 {
      width: calc(20% - 16px);
      background-color: #fff;
      // min-width: 150px;

      .card_4_content {
        display: flex;
        flex-wrap: wrap;
        height: calc(100% - 65px);
        align-items: center;
        color: rgba(0, 0, 0, 0.65);
        > div {
          width: 100%;
          cursor: pointer;
          padding-left: 35px;
          color: #036eb8;
        }
      }
    }
  }
  .xmxy_bottom {
    margin-top: 15px;
    min-height: 380px;
    background-color: #fff;
    .card_5_content {
      display: flex;
      .card_5_content_left {
        width: 75%;
        #card_5_chart {
          height: calc(100% - 46px);
        }
      }
      .card_5_content_right {
        width: 25%;
        padding: 0 15px;
        box-sizing: border-box;
        > div:nth-of-type(2) {
          div {
            height: 44px;
            display: flex;
            justify-content: space-between;
            padding-left: 35px;
            > span:nth-of-type(1) {
              display: flex;
              > .rank_index {
                width: 18px;
                height: 18px;
                border-radius: 50%;
                background-color: #f0f2f5;
                text-align: center;
                line-height: 18px;
                color: rgba(0, 0, 0, 0.65);
                font-size: 12px;
                margin-right: 15px;
              }
            }
          }
          div:nth-child(-n + 3) {
            height: 44px;
            display: flex;
            justify-content: space-between;
            padding-left: 35px;
            > span:nth-of-type(1) {
              display: flex;
              > .rank_index {
                width: 18px;
                height: 18px;
                border-radius: 50%;
                background-color: #314659;
                text-align: center;
                line-height: 18px;
                color: #fff;
                font-size: 12px;
                margin-right: 15px;
              }
            }
          }
        }
      }
      .card_5_suntitle {
        font-size: 16px;
        color: #000;
        font-weight: 600;
        padding: 15px;
      }
    }
  }
  .card_title {
    height: 44px;
    line-height: 44px;
    background-color: #fff;
    padding: 10px;
    font-size: 18px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f3f3f4;
  }
  .tips {
    line-height: 32px;
  }
}
</style>